import { render } from "./newThwHome.vue?vue&type=template&id=3f2f1b19&scoped=true"
import script from "./newThwHome.vue?vue&type=script&lang=js"
export * from "./newThwHome.vue?vue&type=script&lang=js"

import "./newThwHome.vue?vue&type=style&index=0&id=3f2f1b19&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2f1b19"]])

export default __exports__